// extracted by mini-css-extract-plugin
module.exports = {"right_container":"PromoBlockContent_right_container__jMg1E"};